<template>
  <modal :show="showModal" modal-classes="modal-secondary" size="lg">
    <div class="text-center mb-5">
      <h2>{{ $t("SALES_ORDERS.ADD_INVOICE") }}</h2>
    </div>
    <form class="" @submit.prevent="">
      <base-input :label="`${$t('INVOICES.INVOICING_DATE')} (*)`">
        <flat-picker
          :config="{ allowInput: true, locale: $flatPickrLocale() }"
          class="form-control datepicker"
          v-model="invoicing_date"
        />
      </base-input>
      <validation-error :errors="apiValidationErrors.invoicing_date" />
      <!-- <base-input
        :label="`${$t('SALES_ORDERS.INVOICING_TYPE')} (*)`"
        :placeholder="$t('SALES_ORDERS.INVOICING_TYPE')"
        v-if="!salesOrder.invoicing_type"
      >
        <el-select
          :name="`${$t('SALES_ORDERS.INVOICING_TYPE')}`"
          :placeholder="$t('SALES_ORDERS.INVOICING_TYPE')"
          v-model="invoicingType"
        >
          <el-option
            :value="INVOICING_TYPE_PRODUCT"
            :label="$t(`SALES_ORDERS.INVOICING_TYPE_PRODUCT`)"
          />
          <el-option
            :value="INVOICING_TYPE_AMOUNT"
            :label="$t(`SALES_ORDERS.INVOICING_TYPE_AMOUNT`)"
          />
        </el-select>
      </base-input> -->

      <div v-if="invoicingType === INVOICING_TYPE_AMOUNT">
        <base-input
          :label="`${$t('SALES_ORDERS.INVOICE_TYPE')} (*)`"
          :placeholder="$t('SALES_ORDERS.INVOICE_TYPE')"
          input-classes="form-control-alternative"
        >
          <el-select
            :name="`${$t('SALES_ORDERS.INVOICE_TYPE')}`"
            :placeholder="$t('SALES_ORDERS.INVOICE_TYPE')"
            v-model="invoicePartialAmountModel.invoice_type"
          >
            <el-option
              :value="INVOICE_TYPE_DOWNPAYMENT"
              :label="$t(`SALES_ORDERS.INVOICE_TYPE_DOWNPAYMENT`)"
            />
            <el-option
              :value="INVOICE_TYPE_STANDARD"
              :label="$t(`SALES_ORDERS.INVOICE_TYPE_STANDARD`)"
            />
          </el-select>
        </base-input>

        <base-input
          :label="$t('COMMON.EXCERPT')"
          :placeholder="$t('COMMON.EXCERPT')"
          input-classes="form-control-alternative"
        >
          <html-editor
            v-model="invoicePartialAmountModel.excerpt"
            @change="onFormChanged()"
          >
          </html-editor>
        </base-input>

        <base-input
          :label="`${$t('COMMON.AMOUNT')} (*)`"
          :placeholder="$t('COMMON.AMOUNT')"
          v-model="invoicePartialAmountModel.amount"
          type="number"
          step="0.0001"
          input-classes="form-control-alternative"
        >
        </base-input>

        <template v-if="!salesOrder.has_no_taxes">
          <base-input
            :label="$t('COMMON.TAX_GROUPS')"
            :placeholder="$t('COMMON.TAX_GROUPS')"
            input-classes="form-control-alternative"
          >
            <tax-groups-selector
              :taxes="invoicePartialAmountModel.taxGroups"
              @taxGroupsChanged="
                (taxGroups) => {
                  invoicePartialAmountModel.taxGroups = taxGroups;
                }
              "
            />
            <validation-error :errors="apiValidationErrors.taxGroups" />
          </base-input>
        </template>
      </div>

      <div v-if="invoicingType === INVOICING_TYPE_PRODUCT">
        <div
          class="row invoice-item"
          v-for="item in salesOrder.invoicingItemsState.remainingItems"
          :key="item.id"
        >
          <div class="col-6 invoice-item-name">
            <span class="code text-bold h3">{{ item.code }}</span>
            <span class="name">{{ item.name }}</span>
          </div>
          <div class="col-3">
            <base-input
              v-if="invoicePartialProductModel[item.id]"
              :label="`${$t('COMMON.QUANTITY')} (*)`"
              :placeholder="$t('COMMON.QUANTITY')"
              v-model="invoicePartialProductModel[item.id].quantity"
              type="number"
              step="1"
              input-classes="form-control-alternative"
            >
            </base-input>
            <validation-error
              :errors="getItemValidationErrors(item.id, 'quantity')"
            />
          </div>
          <div class="col-3">
            <base-input
              v-if="invoicePartialProductModel[item.id]"
              :label="`${$t('COMMON.UNIT_PRICE')} (*)`"
              :placeholder="$t('COMMON.UNIT_PRICE')"
              v-model="invoicePartialProductModel[item.id].unit_price"
              type="number"
              step="0.0001"
              input-classes="form-control-alternative"
            >
            </base-input>
            <validation-error
              :errors="getItemValidationErrors(item.id, 'unit_price')"
            />
          </div>
        </div>
      </div>
    </form>

    <template slot="footer">
      <button
        type="submit"
        class="btn btn-primary"
        @click="handleSubmit"
        :disabled="loading"
      >
        <span v-if="loading" class="btn-inner--icon">
          <i class="fas fa-spinner fa-spin"></i>
        </span>
        {{ $t("SALES_ORDERS.ADD_INVOICE") }}
      </button>

      <button
        type="button"
        class="btn btn-link ml-auto"
        @click="closeSalesOrderInvoiceForm"
        :disabled="loading"
      >
        {{ $t("COMMON.CLOSE") }}
      </button>
    </template>
  </modal>
</template>

<script>
import {
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { cloneDeep } from "lodash";
import formMixin from "@/mixins/form-mixin";
import {
  INVOICING_TYPE_PRODUCT,
  INVOICING_TYPE_AMOUNT,
  INVOICE_TYPE_DOWNPAYMENT,
  INVOICE_TYPE_STANDARD,
} from "@/constants/invoices";
import requestErrorMixin from "@/mixins/request-error-mixin";
import ValidationError from "@/components/ValidationError.vue";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import TaxGroupsSelector from "@/components/TaxGroupsSelector.vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

export default {
  components: {
    ValidationError,
    HtmlEditor,
    TaxGroupsSelector,
    flatPicker,
    [Tooltip.name]: Tooltip,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  mixins: [formMixin, requestErrorMixin],

  props: ["salesOrder", "showModal"],

  data() {
    return {
      invoicePartialProductModel: [],
      invoicePartialAmountModel: {
        invoice_type: INVOICE_TYPE_STANDARD,
        amount: 0,
        excerpt: "",
      },
      invoicing_date: moment().format("YYYY-MM-DD"),
      invoicingType: INVOICING_TYPE_PRODUCT,
      loading: false,
      INVOICING_TYPE_AMOUNT: INVOICING_TYPE_AMOUNT,
      INVOICING_TYPE_PRODUCT: INVOICING_TYPE_PRODUCT,
      INVOICE_TYPE_DOWNPAYMENT: INVOICE_TYPE_DOWNPAYMENT,
      INVOICE_TYPE_STANDARD: INVOICE_TYPE_STANDARD,
      formErrors: null,
    };
  },

  computed: {},

  methods: {
    getDefaultInvoicingDate() {
      if (this.salesOrder?.event_date) {
        return this.$timeZoneDateFormat(this.salesOrder.event_date, "YYYY-MM-DD");
      }

      return moment().format("YYYY-MM-DD");
    },

    getItemValidationErrors(itemId, field) {
      const itemKey = `items.${itemId}.${field}`;
      if (this.apiValidationErrors[itemKey]) {
        return this.apiValidationErrors[itemKey];
      }
      if (this.apiValidationErrors[field]) {
        return this.apiValidationErrors[field];
      }
      return null;
    },

    setInvoicePartialProductModel() {
      if (this.salesOrder.invoicingItemsState.remainingItems) {
        const invoiceItemsData = {};
        for (const item of Object.values(
          this.salesOrder.invoicingItemsState.remainingItems
        )) {
          const existingItem = this.invoicePartialProductModel[item.id] || {};
          invoiceItemsData[item.id] = {
            id: item.id,
            quantity:
              typeof existingItem.quantity !== "undefined"
                ? existingItem.quantity
                : item.quantity,
            unit_price:
              typeof existingItem.unit_price !== "undefined"
                ? existingItem.unit_price
                : item.unit_price,
          };
        }
        this.invoicePartialProductModel = invoiceItemsData;
        this.invoicingType = this.salesOrder.invoicing_type
          ? this.salesOrder.invoicing_type
          : INVOICING_TYPE_PRODUCT;
      }
    },

    setInvoicePartialAmountModel() {
      this.invoicePartialAmountModel.amount =
        this.salesOrder.invoicingAmountsState.remainingInvoiceAmount;
    },

    closeSalesOrderInvoiceForm() {
      this.$emit("closeSalesOrderInvoiceForm", true);
    },

    async handleSubmit() {
      try {
        this.loading = true;
        let invoiceItems = {};
        if (this.invoicingType === INVOICING_TYPE_PRODUCT) {
          invoiceItems = cloneDeep(this.invoicePartialProductModel);
        } else if (this.invoicingType === INVOICING_TYPE_AMOUNT) {
          invoiceItems = cloneDeep(this.invoicePartialAmountModel);
        }

        const salesInvoice = await this.$store.dispatch(
          "salesOrders/generateInvoice",
          {
            id: this.salesOrder.id,
            invoicingType: this.invoicingType,
            invoicing_date: this.$getUtcDateTimeString(
              moment(this.invoicing_date).hour(12).minute(0).second(0).toISOString()
            ),
            items: invoiceItems,
          }
        );
        this.$notify({
          type: "success",
          message: this.$t("SALES_ORDERS.SALES_ORDER_INVOICE_ADDED"),
        });
        this.$router.push(this.$objectViewRoute(salesInvoice));
      } catch (error) {
        await this.showRequestError(error);
        this.setApiValidation(error.response.data.errors);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async generateInvoice() {},
  },

  mounted() {},

  watch: {
    showModal() {
      this.invoicing_date = this.getDefaultInvoicingDate();
      this.setInvoicePartialProductModel();
      this.setInvoicePartialAmountModel();
    },
    salesOrder() {},
  },
};
</script>

<style scoped>
.invoice-item .invoice-item-name {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
